import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import Collection from './generic/collection'
import { getCfg } from './utils/getCfg'
import Placeholder from '../components/calculate-table/components/loader'

const App = lazy(() => import(/* webpackChunkName: "Price calculator" */"../components/calculate-table/App"))

export const instance = '[data-js-calculate-table]'

export class CalculateTable {

  static els = {
    instance,
  }

  static defaultCfg = { baseClass: "CalculateTable", localeKey: CalculateTable.els.instance }

  constructor (instance) {
    this.instance = instance
    this.init()
  }

  init() {
    this.cfg = getCfg(this.instance, CalculateTable.els.instance, CalculateTable.defaultCfg);
    ReactDOM.render(
      <Suspense fallback={<Placeholder/>}>
          <App {...this.cfg} />
      </Suspense>, this.instance
    )
  }
}

export class CalculateTableCollection extends Collection {
  constructor() {
    super(instance, CalculateTable)
    this.init()
  }
  init(context = document) {
    context.querySelectorAll(instance).forEach((el) => {
      this.collection = new CalculateTable(el)
    })
  }
}